(function () {
  document.querySelectorAll('[data-jra]').forEach(function (root) {
    var rows = [], vars = {};
    try { rows = JSON.parse(root.querySelector('[data-jra-rows]').textContent) || []; } catch (e) {}
    try { vars = JSON.parse(root.querySelector('[data-jra-vars]').textContent) || {}; } catch (e) {}
    // Varianten über 250 (nicht in Liquid verfügbar) aus dem Metafeld ergänzen; Bild von einer Variante gleicher Farbe
    try {
      var moreEl = root.querySelector('[data-jra-more]');
      var more = moreEl ? JSON.parse(moreEl.textContent) || {} : {};
      var imgByFinish = {};
      rows.forEach(function (r) { var v = vars[r.s]; if (v && v.img && !imgByFinish[r.f]) imgByFinish[r.f] = v.img; });
      rows.forEach(function (r) {
        var m = more[r.s];
        if (vars[r.s] || !m) return;
        vars[r.s] = { id: m[0], cents: m[1], price: 'CHF ' + (m[1] / 100).toFixed(2), compare: null, available: true, img: imgByFinish[r.f] || null };
      });
      rows.forEach(function (r) { var v = vars[r.s]; if (v && !v.img && imgByFinish[r.f]) v.img = imgByFinish[r.f]; });
    } catch (e) {}
    var buy = root.dataset.mode === 'kauf';
    if (!rows.length) { root.hidden = true; return; }
    var $ = function (s) { return root.querySelector(s); };
    var esc = function (v) { return String(v).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); };
    var uniq = function (a) { return a.filter(function (v, i) { return a.indexOf(v) === i; }); };
    var sizeKey = function (z) { var p = z.split('x'); return parseFloat(p[0]) * 100 + parseFloat(p[1] || 0); };
    var etText = function (e) {
      var n = e.map(Number).filter(function (x) { return !isNaN(x); });
      if (!n.length) return e.join(', ');
      var lo = Math.min.apply(null, n), hi = Math.max.apply(null, n);
      return lo === hi ? 'ET' + lo : 'ET' + lo + ' bis ' + hi;
    };

    // Farbwert aus dem Farbnamen ableiten (Herstellerfarben wie "Matt Bronze", "Gloss Candy Apple Red")
    var HINTS = [['custom', 'conic-gradient(#B3121B, #C29A4E, #2E6B3A, #1C3F94, #5b3fa0, #B3121B)'],
      ['blue-purple', 'linear-gradient(135deg,#2a3f9e,#6b2fa0)'], ['bronze-green', 'linear-gradient(135deg,#8C6B3E,#2E6B3A)'],
      ['light gunmetal', '#6E6D69'], ['gun', '#4A4844'], ['graphite', '#3E3D3A'], ['bronze', '#8C6B3E'], ['gold', '#B49455'],
      ['silver', '#C9C4B8'], ['white', '#EDEAE2'], ['apple red', '#B3121B'], ['red', '#B3121B'], ['apple green', '#3E8E3A'],
      ['green', '#2E6B3A'], ['violet', '#5b2f8a'], ['purple', '#5b2f8a'], ['blue', '#1C3F94'], ['titan', '#9C9A94'], ['black', '#1A1A1A']];
    var hexOf = function (name) {
      var n = String(name).toLowerCase();
      var hit = HINTS.filter(function (h) { return n.indexOf(h[0]) !== -1; })[0];
      return hit ? hit[1] : '#888';
    };
    var isMatt = function (name) { return /matt/i.test(name); };
    function swatches(box, values, current, key) {
      box.innerHTML = values.map(function (v) {
        return '<button type="button" class="jra__sw' + (isMatt(v) ? ' is-matt' : '') + '" data-k="' + key + '" data-v="' + esc(v) + '" aria-pressed="' + (v === current) + '" aria-label="' + esc(v) + '" title="' + esc(v) + '"><span style="background:' + hexOf(v) + '"></span></button>';
      }).join('');
    }

    var sizes = uniq(rows.map(function (r) { return r.z; })).sort(function (a, b) { return sizeKey(a) - sizeKey(b); });
    var s = { size: sizes[0], finish: null, row: null };

    function pills(box, values, current, key) {
      box.innerHTML = values.map(function (v) {
        return '<button type="button" data-k="' + key + '" data-v="' + esc(v) + '" aria-pressed="' + (v === current) + '">' + esc(v) + '</button>';
      }).join('');
    }
    function fillSelect(sel, values, keep) {
      var cur = keep ? sel.value : null;
      sel.innerHTML = values.map(function (v) { return '<option value="' + esc(v) + '">' + esc(v) + '</option>'; }).join('');
      if (cur && values.indexOf(cur) !== -1) sel.value = cur;
    }

    function render() {
      pills($('[data-jra-sizes]'), sizes, s.size, 'size');
      var forSize = rows.filter(function (r) { return r.z === s.size; });
      var finishes = uniq(forSize.map(function (r) { return r.f; }));
      if (finishes.indexOf(s.finish) === -1) s.finish = finishes[0];
      swatches($('[data-jra-finishes]'), finishes, s.finish, 'finish');
      $('[data-jra-finish-name]').textContent = '— ' + s.finish;

      updateOptions();
    }

    var pcdKey = function (p) { var a = p.split('x'); return parseInt(a[0], 10) * 1000 + parseFloat(a[1]); };
    // Lieferzeit in Tagen: "3 - 14 days" -> 14; Datum "2026-11-23" (erwartete Ankunft) -> Tage bis dahin; "-" -> unbekannt
    var maxDays = function (t) {
      t = String(t || '').trim();
      var iso = t.match(/^(\d{4})-(\d{2})-(\d{2})$/);
      if (iso) return Math.max(0, Math.ceil((new Date(+iso[1], +iso[2] - 1, +iso[3]) - new Date()) / 86400000));
      var n = t.match(/\d+/g);
      return n ? Math.max.apply(null, n.map(Number)) : null;
    };
    var shipText = function (t) {
      t = String(t || '').trim();
      var iso = t.match(/^(\d{4})-(\d{2})-(\d{2})$/);
      if (iso) return 'voraussichtlich ab ' + iso[3] + '.' + iso[2] + '.' + iso[1];
      return t.replace('days', 'Tage');
    };
    // Lochkreis- und ET-Auswahl aus allen Herstellerzeilen der gewählten Grösse und Farbe;
    // die passende Zeile (Artikel) wird im Hintergrund bestimmt, bei mehreren die schnellste Lieferung.
    function updateOptions() {
      var cands = rows.filter(function (r) { return r.z === s.size && r.f === s.finish; });
      var pcds = uniq([].concat.apply([], cands.map(function (r) { return r.p; }))).sort(function (a, b) { return pcdKey(a) - pcdKey(b); });
      if (pcds.indexOf(s.pcd) === -1) s.pcd = pcds[0];
      fillSelect($('[data-jra-pcd]'), pcds, false);
      $('[data-jra-pcd]').value = s.pcd;
      var withPcd = cands.filter(function (r) { return r.p.indexOf(s.pcd) !== -1; });
      var ets = uniq([].concat.apply([], withPcd.map(function (r) { return r.e; }))).sort(function (a, b) { return Number(a) - Number(b); });
      if (ets.indexOf(s.et) === -1) s.et = ets[0];
      fillSelect($('[data-jra-et]'), ets.map(function (e) { return 'ET' + e; }), false);
      $('[data-jra-et]').value = 'ET' + s.et;
      var match = withPcd.filter(function (r) { return r.e.indexOf(s.et) !== -1; })
        .sort(function (a, b) {
          // zuerst Artikel mit Preis, dann schnellste Lieferung
          var pa = (vars[a.s] || {}).cents > 0 ? 0 : 1, pb = (vars[b.s] || {}).cents > 0 ? 0 : 1;
          return pa - pb || (maxDays(a.t) || 99) - (maxDays(b.t) || 99);
        });
      selectRow(match[0] || withPcd[0] || cands[0]);
    }

    function selectRow(r) {
      s.row = r;
      var cw = $('[data-jra-custom-wrap]');
      if (r.c && r.c.length) {
        cw.hidden = false;
        if (r.c.indexOf(s.custom) === -1) s.custom = r.c[0];
        swatches($('[data-jra-custom]'), r.c, s.custom, 'custom');
        $('[data-jra-custom-name]').textContent = '— ' + s.custom;
      } else { cw.hidden = true; }
      // Nur die Lieferzeit anzeigen (Artikelnummer, CB und Traglast gehen weiter mit der Bestellung/Anfrage)
      var html = '';
      if (r.t && r.t.trim() !== '-') {
        // Ampel: grün bis 5 Tage, gelb bis 14 Tage, rot darüber
        var d = maxDays(r.t), lvl = d === null ? 'mid' : d <= 5 ? 'fast' : d <= 14 ? 'mid' : 'slow';
        var hint = { fast: 'Schnell lieferbar', mid: 'Normale Lieferzeit', slow: 'Längere Lieferzeit' }[lvl];
        html += '<dt>Lieferzeit</dt><dd><span class="jra__ship jra__ship--' + lvl + '"><i aria-hidden="true"></i>' + esc(shipText(r.t)) + ' <small>' + hint + '</small></span></dd>';
      } else {
        html += '<dt>Lieferzeit</dt><dd><span class="jra__ship jra__ship--mid"><i aria-hidden="true"></i>Auf Anfrage</span></dd>';
      }
      $('[data-jra-facts]').innerHTML = html;
      // Bild der Farbe zeigen
      var v = vars[r.s] || {};
      var src = v.img;
      var main = document.querySelector('[data-pdp-media] img');
      if (src && main && main.getAttribute('src') !== src) { main.removeAttribute('srcset'); main.src = src; main.classList.add('is-photo'); }
      sync();
    }

    function sync() {
      var r = s.row; if (!r) return;
      var finish = r.f + (r.c && r.c.length ? ': ' + s.custom : '');
      var v = vars[r.s] || {};
      var out = { sku: r.s, size: r.z, finish: finish, pcd: $('[data-jra-pcd]').value, et: $('[data-jra-et]').value, id: v.id || '', custom: r.c && r.c.length ? s.custom : '' };
      if (buy) {
        var customEl = root.querySelector('[data-jra-out="custom"]');
        if (customEl) customEl.disabled = !(r.c && r.c.length);
        var priceEl = $('[data-jra-price]');
        if (priceEl) priceEl.textContent = v.price || '';
        var cmpEl = $('[data-jra-compare]');
        if (cmpEl) {
          // Anzeige-Element: durchgestrichener Wert = Preis + 15 % (auf 5 Rappen), ändert keine Shopify-Preise
          var cmpText = v.compare || '';
          if (!cmpText && v.cents > 0) {
            var hi = Math.round(v.cents * 1.15 / 5) * 5 / 100;
            cmpText = 'CHF ' + hi.toFixed(2);
          }
          cmpEl.textContent = cmpText;
          cmpEl.hidden = !(cmpText && v.cents > 0);
        }
        var form = root.closest('form'), btn = form && form.querySelector('[type="submit"]');
        if (btn) {
          var ok = v.id && v.available !== false && v.cents > 0;
          btn.disabled = !ok;
          btn.textContent = ok ? 'In den Warenkorb' : (v.cents > 0 ? 'Nicht verfügbar' : 'Preis auf Anfrage');
          if (priceEl && !(v.cents > 0)) priceEl.textContent = 'auf Anfrage';
          // Lieferzeit oder Preis auf Anfrage -> Kontaktformular statt Warenkorb
          var noShip = !r.t || r.t.trim() === '-';
          var inquire = !ok || noShip;
          var buyBox = form.querySelector('[data-jra-buy]');
          var inq = document.getElementById('jra-inquiry');
          if (buyBox) buyBox.hidden = inquire;
          if (inq) {
            inq.hidden = !inquire && !inq.querySelector('[data-jra-inq-posted]');
            var reason = inq.querySelector('[data-jra-inq-reason]');
            if (reason) reason.textContent = noShip && ok ? 'Die Lieferzeit für diese Ausführung klären wir für Sie – senden Sie uns eine Anfrage.' : 'Für diese Ausführung erhalten Sie Preis und Lieferzeit auf Anfrage.';
            var map = { sku: r.s, size: r.z, finish: finish, pcd: out.pcd, et: out.et };
            Object.keys(map).forEach(function (k) { var el = inq.querySelector('[data-jra-inq="' + k + '"]'); if (el) el.value = map[k]; });
          }
          if (priceEl && noShip && ok) priceEl.textContent = v.price;
        }
      }
      Object.keys(out).forEach(function (k) { var el = root.querySelector('[data-jra-out="' + k + '"]'); if (el) el.value = out[k]; });
    }

    root.addEventListener('click', function (e) {
      var b = e.target.closest('button[data-k]');
      if (!b) return;
      var k = b.getAttribute('data-k');
      s[k] = b.getAttribute('data-v');
      if (k === 'custom') { selectRow(s.row); return; }
      render();
    });
    $('[data-jra-pcd]').addEventListener('change', function () { s.pcd = this.value; updateOptions(); });
    $('[data-jra-et]').addEventListener('change', function () { s.et = this.value.replace(/^ET/, ''); updateOptions(); });

    render();
  });

  // Vorschaubilder anklickbar
  document.querySelectorAll('[data-pdp-thumb]').forEach(function (t) {
    t.addEventListener('click', function () {
      var main = document.querySelector('[data-pdp-media] img');
      if (main) { main.removeAttribute('srcset'); main.src = t.getAttribute('data-full'); main.classList.add('is-photo'); }
    });
  });
})();
